<template>
  <section id="textBlock">
    <div class="title">
      <h1>{{$t("textBlock.title")}}</h1>
    </div>
    <div class="text">
      <p style="white-space: pre-line">{{$t("textBlock.text")}}</p>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
#textBlock {
  padding: 30px 20% 30px 20%;
  max-width: 100%;
}

h1 {
  font-family: "Neue Montreal", sans-serif;
  font-weight: 600;
}

p {
  font-family: "Acre", sans-serif;
  font-weight: 400;
  font-size: 1.2rem;
}

.card {
  height: 300px;
}
</style>
